import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';
import script from './HseRichInput.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hse-RichInput",class:{ 'hse-RichInput_hasError': _vm.hasError}},[(_vm.label || _vm.$slots.label)?_c('div',{staticClass:"hse-RichInput__label",class:_vm.classes.label},[_vm._t("label",[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")])],2):_vm._e(),_vm._v(" "),_vm._t("default",[_c(_vm.tag,_vm._g(_vm._b({tag:"component",class:_vm.classes.component,attrs:{"error":Boolean(_vm.errorMessage)}},'component',Object.assign({}, _vm.$attrs, {value: _vm.value}),false),_vm.$listeners),[_vm._l((_vm.$slots),function(_,name){return _vm._t(name,null,{"slot":name})})],2)]),_vm._v(" "),(_vm.hasMessage)?_c('div',{staticClass:"hse-RichInput__message",class:_vm.classes.message},[_vm._t(_vm.messageSlotName,[_vm._v("\n      "+_vm._s(_vm.errorMessage || _vm.hint)+"\n    ")])],2):_vm._e()],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
